"use strict";

var _classCallCheck = require("/tmp/build_afa5e9373483510c3650f3d80edeec0c/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_afa5e9373483510c3650f3d80edeec0c/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var DOMException = require("domexception");

var SVGNumberImpl =
/*#__PURE__*/
function () {
  function SVGNumberImpl(args, privateData) {
    _classCallCheck(this, SVGNumberImpl);

    // Delegate to parent List object for (almost) everything related to reflection.
    this._parentList = privateData.parentList;
    this._value = 0;
  }

  _createClass(SVGNumberImpl, [{
    key: "_synchronize",
    value: function _synchronize() {
      if (this._parentList !== undefined) {
        this._parentList._synchronize();
      }
    }
  }, {
    key: "_reserialize",
    value: function _reserialize() {
      if (this._parentList !== undefined) {
        this._parentList._reserialize();
      }
    }
  }, {
    key: "_readOnly",
    get: function get() {
      if (this._parentList !== undefined) {
        return this._parentList._readOnly;
      }

      return false;
    }
  }, {
    key: "value",
    get: function get() {
      this._synchronize();

      return this._value;
    },
    set: function set(value) {
      if (this._readOnly) {
        throw new DOMException("Attempting to modify a read-only SVGNumber", "NoModificationAllowedError");
      }

      this._value = value;

      this._reserialize();
    }
  }]);

  return SVGNumberImpl;
}();

exports.implementation = SVGNumberImpl;